import { NotifyHelper } from "../../../helpers/toast";
import { eQuyCheActionsObj } from "../../action-types/category/IQuyCheActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const quyCheActions = {
    ...generateActions(eQuyCheActionsObj, "QUY_CHE"),
    ...generateActionForKey(eQuyCheActionsObj, "QUY_CHE", "SAVE_SUCCESS", () => {NotifyHelper.Success("Thành công")}),
    ...generateActionForKey(eQuyCheActionsObj, "QUY_CHE", "DELETE_SUCCESS", () => {NotifyHelper.Success("Thành công")}),
    ...generateActionForKey(eQuyCheActionsObj, "QUY_CHE", "SAVE_ERROR", (m) => {NotifyHelper.Error(m)}),
    ...generateActionForKey(eQuyCheActionsObj, "QUY_CHE", "DELETE_ERROR", (m) => {NotifyHelper.Error(m)}),
}